interface Options {
  parent?: 'header' | 'footer';
  platform?: 'desktop' | 'mobile';
}

export const getTrackingId = (element: string, options?: Options) => {
  const prefix = 'ga';

  const idComponents = [
    prefix,
    ...(options?.platform ? [options.platform] : []),
    ...(options?.parent ? [options.parent] : []),
    element,
  ];

  return idComponents.join('.');
};
